import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzStepsModule } from 'ng-zorro-antd/steps';

@Component({
  selector: 'korviu-steps',
  standalone: true,
  imports: [TranslateModule, NzStepsModule],
  templateUrl: './korviu-steps.component.html',
  styleUrls: ['./korviu-steps.component.scss']
})
export class KorviuStepsComponent {
  @Input() public current: number = 0;
  @Input() public steps: string[] = [];

  constructor() {}
}
